import React, { useState } from "react";
import { connect } from "react-redux";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Box,
    Typography,
    IconButton,
    CircularProgress,
    Avatar
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MapIcon from '@mui/icons-material/Map'; // Using Map icon for territory
import TerritoryAddOrUpdate from "./TerritoryAddOrUpdate";
import PndRestApi from "src/utils/pnd/PndRestApi";
import { showNotification, successNofication } from "src/shared/components/Notification";
import { ERROR_MESSAGES, PAGE_TIMEOUT } from "src/utils/pnd/PndConstants";

const TerritoryModal = ({ modalShow, setModalShow, isTitle, dataInfo }) => {
    const [isRedirect, setIsRedirect] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleClose = () => {
        setModalShow(false);
    };

    if (isRedirect) {
        window.location.reload();
    }

    const handleSubmit = async (formValues) => {
        try {
            let obj = {};
            setLoading(true);
            const selectedValues = formValues.areaInfo || [];
            const areaIds = selectedValues.map(option => option.value).join(', ');
            obj["regionCode"] = formValues["regionCode"];
            obj["regionName"] = formValues["regionName"];
            obj["regionAreaIds"] = areaIds;
            obj["regionId"] = formValues["regionId"];

            const response = await PndRestApi.AddOrUpdateTerritory(obj);
            if (response.status === 200 && response.data.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    ERROR_MESSAGES.successMessage,
                );
                setTimeout(() => {
                    setIsRedirect(true);
                }, PAGE_TIMEOUT);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={modalShow}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '16px',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
                }
            }}
        >
            <DialogTitle sx={{
                m: 0,
                p: 2,
                bgcolor: '#ffffff',
                borderBottom: '1px solid #f1f5f9',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Avatar sx={{ bgcolor: '#e0f2fe', color: '#0ea5e9' }}>
                        <MapIcon />
                    </Avatar>
                    <Typography variant="h6" component="div" sx={{ fontWeight: 700, color: '#1e293b' }}>
                        {isTitle || "Territory Details"}
                    </Typography>
                </Box>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        color: (theme) => theme.palette.grey[500],
                        '&:hover': {
                            backgroundColor: '#f1f5f9',
                            color: '#ef4444'
                        }
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ p: 3, bgcolor: '#f8fafc' }}>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <TerritoryAddOrUpdate
                        onSubmit={handleSubmit}
                        dataInfo={dataInfo}
                        regionId={dataInfo?.regionId}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
};

export default connect((state) => ({
    rtl: state.rtl,
}))(TerritoryModal);
